import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';

import { LoadingModalComponent } from './loading-modal-page';

export interface LoadingModalOptions {
  message: string;
  showCancelButton?: boolean;
  subtitle?: Observable<string>;
}

@Injectable({ providedIn: 'root' })
export class LoadingModalService {
  constructor(private _modalController: ModalController) {}

  async present(options: LoadingModalOptions): Promise<HTMLIonModalElement> {
    const modal = await this._modalController.create({
      cssClass: 'loading-modal',
      component: LoadingModalComponent,
      showBackdrop: true,
      backdropDismiss: false,
      componentProps: {
        message: options.message,
        showCancelButton: options.showCancelButton ?? true,
        subtitle: options.subtitle,
      },
    });
    await modal.present();
    return modal;
  }
}
